import { Box, Divider } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppMeta, useAuth } from "hooks";
import { useGetVendorDataDetailQuery } from "store/services/CanUsers/vendorApi";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import VendorBasicDetails from "./vendorComponents/VendorBasicDetails";
import { VendorDetailContext } from "contexts/Contacts/VendorContext";
import UserAccess from "components/User/UserAccess";
import CustomTabs from "components/Shared/CustomTabs";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { VendorProfileTab } from "./vendorComponents/VendorProfileTab";

const VendorDetailScreen = () => {

  const { isAccountAdmin, isSystemAdmin } = useAuth();

  const { id } = useParams();
  
  const [searchParams] = useSearchParams();

  const breadcrumbs = [
    { title: "Vendor", path: "/app/crm/vendor/list" },
    { title: "Vendor Detail" },
  ];

  const vendorProfileDetailTabs = [
    {
      label: "Vendor Profile",
      value: "vendor-profile",
    },
  ];

  const activeTab = searchParams.get("tab") || "vendor-profile";

  const {
    data: vendorDetail,
    isLoading: loadingDetail,
    error,
  } = useGetVendorDataDetailQuery(id);

  const PageActions = () => (
    <Box display="flex" alignItems="center" gap={2}>
      {(isSystemAdmin || isAccountAdmin) && (
        <UserAccess sourceDetail={vendorDetail} />
      )}

      {/* <Link to={`/app/crm/vendor/${id}/edit`} state={{ from: "detail" }}>
        <Button variant="contained" startIcon={<EditOutlined />}>
          Edit
        </Button>
      </Link> */}
    </Box>
  );

  useAppMeta("Vendor Detail");

  return (
    <VendorDetailContext.Provider value={{ vendorDetail, loadingDetail }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingDetail}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <VendorBasicDetails />
          <Divider />

          <CustomTabs tabs={vendorProfileDetailTabs} activeTab={activeTab} />
          {!loadingDetail ? (
            <>
              <CustomTabPanel activeTab={activeTab} value="vendor-profile">
                <VendorProfileTab />
              </CustomTabPanel>
            </>
          ) : (
            <RowsSkeleton />
          )}
          {/* <VendorDetailTabs /> */}
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </VendorDetailContext.Provider>
  );
};

export default VendorDetailScreen;
